import { Link } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';

export function RegisterPage() {

  return (
    <div className="bg-unicorn-mesh-light dark:bg-none dark:bg-background-dark text-slate-900 dark:text-white overflow-x-hidden antialiased transition-colors duration-300 min-h-screen relative flex flex-col font-sans">
      <style>{`
        .material-symbols-outlined { font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24; }
        .filled-icon { font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24; }
        ::-webkit-scrollbar { width: 8px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        ::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
        .dark ::-webkit-scrollbar-thumb { background: #334155; }
        .dark ::-webkit-scrollbar-thumb:hover { background: #475569; }
        .gradient-text {
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            background-image: linear-gradient(to right, #3B52D0, #4194F2, #A378CF, #F0766E);
        }
        .glass-card {
            background: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.5);
        }
        .dark .glass-card {
            background: rgba(15, 23, 42, 0.6);
            border: 1px solid rgba(255, 255, 255, 0.05);
        }
        .hover-card {
            transition: all 0.3s ease;
        }
        .hover-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }
      `}</style>

      <div className="fixed inset-0 z-[-1] opacity-0 dark:opacity-40 bg-unicorn-mesh pointer-events-none transition-opacity duration-500"></div>

      <Navbar variant="auth" />

      <main className="flex-grow flex flex-col items-center justify-center py-12 px-4 md:px-8 relative overflow-hidden">
        {/* Animated Blobs */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full -z-10 pointer-events-none opacity-60 dark:opacity-30">
          <div className="absolute top-[5%] left-[15%] w-[500px] h-[500px] bg-[#3B52D0]/20 rounded-full blur-[100px] animate-pulse-slow"></div>
          <div className="absolute bottom-[10%] right-[15%] w-[400px] h-[400px] bg-[#F0766E]/20 rounded-full blur-[100px] animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-[40%] right-[30%] w-[300px] h-[300px] bg-[#A378CF]/10 rounded-full blur-[80px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
        </div>

        <div className="max-w-[800px] w-full text-center mb-12 relative z-10">
          <h1 className="text-slate-900 dark:text-white text-4xl md:text-5xl font-black leading-tight tracking-[-0.033em] mb-4 font-display">
            <span className="bg-logo-text text-transparent bg-clip-text">Join the Future</span><br />of Startup Evaluation
          </h1>
          <p className="text-slate-600 dark:text-slate-400 text-lg md:text-xl font-normal leading-relaxed max-w-2xl mx-auto">
            Choose your path to get started with AI-powered analysis.
          </p>
        </div>

        <div className="max-w-[1100px] w-full grid grid-cols-1 md:grid-cols-[1.3fr_1fr] gap-6 items-stretch relative z-10">

          {/* Investor Card */}
          <div className="glass-card hover-card group relative flex flex-col rounded-2xl p-8 shadow-xl overflow-hidden border border-white/50 dark:border-slate-700">
            <div className="absolute top-0 left-0 w-full h-1 bg-logo-gradient"></div>
            <div className="flex flex-col h-full">
              <div className="mb-6">
                <div className="w-14 h-14 rounded-2xl bg-[#4f46e5]/10 flex items-center justify-center text-[#4f46e5] mb-4 text-3xl group-hover:scale-110 transition-transform duration-300">
                  <span className="material-symbols-outlined">trending_up</span>
                </div>
                <h2 className="text-slate-900 dark:text-white text-3xl font-bold leading-tight mb-2 font-display">For Investors</h2>
                <p className="text-slate-600 dark:text-slate-400 text-base">Unlock advanced AI tools to streamline your deal flow.</p>
              </div>
              <div className="flex-grow space-y-5 mb-8">
                <div className="flex gap-4 items-start">
                  <div className="p-1.5 rounded-full bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 mt-1">
                    <span className="material-symbols-outlined text-sm font-bold block">check</span>
                  </div>
                  <div>
                    <h3 className="text-slate-900 dark:text-slate-200 font-bold">Instant Due Diligence</h3>
                    <p className="text-slate-500 dark:text-slate-400 text-sm">Get AI-generated reports instantly.</p>
                  </div>
                </div>
                <div className="flex gap-4 items-start">
                  <div className="p-1.5 rounded-full bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 mt-1">
                    <span className="material-symbols-outlined text-sm font-bold block">check</span>
                  </div>
                  <div>
                    <h3 className="text-slate-900 dark:text-slate-200 font-bold">Rapid Screening</h3>
                    <p className="text-slate-500 dark:text-slate-400 text-sm">Screen hundreds of startups in minutes.</p>
                  </div>
                </div>
                <div className="flex gap-4 items-start">
                  <div className="p-1.5 rounded-full bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 mt-1">
                    <span className="material-symbols-outlined text-sm font-bold block">check</span>
                  </div>
                  <div>
                    <h3 className="text-slate-900 dark:text-slate-200 font-bold">Standardized Scoring</h3>
                    <p className="text-slate-500 dark:text-slate-400 text-sm">Use standardized metrics for unbiased comparison.</p>
                  </div>
                </div>
              </div>
              <Link to="/register-investor" className="w-full h-12 flex items-center justify-center rounded-lg bg-logo-gradient hover:shadow-lg hover:shadow-[#4f46e5]/30 text-white text-base font-bold transition-all transform hover:-translate-y-0.5">
                Register as Investor
              </Link>
            </div>
          </div>

          {/* Startup Card */}
          <div className="glass-card hover-card flex flex-col rounded-2xl p-8 border border-white/50 dark:border-slate-700 shadow-lg md:opacity-90 hover:opacity-100 transition-all duration-300">
            <div className="flex flex-col h-full">
              <div className="mb-6">
                <div className="w-14 h-14 rounded-2xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-600 dark:text-slate-300 mb-4 group-hover:scale-110 transition-transform duration-300">
                  <span className="material-symbols-outlined text-3xl">rocket_launch</span>
                </div>
                <h2 className="text-slate-900 dark:text-white text-2xl font-bold leading-tight mb-2 font-display">For Startups</h2>
                <p className="text-slate-600 dark:text-slate-400 text-base">Get objective feedback to refine your pitch.</p>
              </div>
              <div className="flex-grow space-y-5 mb-8">
                <div className="flex gap-4 items-start">
                  <span className="material-symbols-outlined text-[#4f46e5] mt-1">handshake</span>
                  <div>
                    <h3 className="text-slate-900 dark:text-slate-200 font-bold">Get easy access to Investors</h3>
                    <p className="text-slate-500 dark:text-slate-400 text-sm">Connect with the right funding partners.</p>
                  </div>
                </div>
                <div className="flex gap-4 items-start">
                  <span className="material-symbols-outlined text-[#4f46e5] mt-1">analytics</span>
                  <div>
                    <h3 className="text-slate-900 dark:text-slate-200 font-bold">Gap identification</h3>
                    <p className="text-slate-500 dark:text-slate-400 text-sm">Spot weaknesses and missing data.</p>
                  </div>
                </div>
                <div className="flex gap-4 items-start">
                  <span className="material-symbols-outlined text-[#4f46e5] mt-1">bolt</span>
                  <div>
                    <h3 className="text-slate-900 dark:text-slate-200 font-bold">Raise money faster</h3>
                    <p className="text-slate-500 dark:text-slate-400 text-sm">Accelerate your fundraising process.</p>
                  </div>
                </div>
              </div>
              <Link to="/register-startup" className="w-full h-12 flex items-center justify-center rounded-lg bg-transparent border-2 border-slate-200 dark:border-slate-600 text-slate-900 dark:text-white hover:border-[#4f46e5] hover:text-[#4f46e5] dark:hover:border-[#4f46e5] dark:hover:text-[#4f46e5] text-base font-bold transition-all">
                Register as Startup
              </Link>
            </div>
          </div>

        </div>

        <div className="mt-12 text-center relative z-10">
          <p className="text-slate-500 dark:text-slate-500 text-lg">
            Already have an account? <Link className="text-[#4f46e5] font-semibold hover:underline" to="/auth/login">Log in here</Link>
          </p>
        </div>
      </main>

      <footer className="bg-white/50 dark:bg-slate-900 border-t border-indigo-100 dark:border-slate-800 py-8 backdrop-blur-sm mt-auto relative z-10">
        <div className="max-w-[1280px] mx-auto px-4 text-center">
          <div className="flex items-center justify-center gap-2 mb-4 text-slate-400 dark:text-slate-600">
            <img alt="uniscout Logo" className="h-6 w-auto opacity-50 grayscale" src="/logo.png" />
          </div>
          <div className="flex justify-center gap-6 mb-4 flex-wrap text-sm">
            <Link className="text-slate-500 hover:text-[#4f46e5] transition-colors" to="/privacy-policy">Privacy Policy</Link>
            <Link className="text-slate-500 hover:text-[#4f46e5] transition-colors" to="/terms-of-service">Terms of Service</Link>
            <a className="text-slate-500 hover:text-[#4f46e5] transition-colors" href="#">Contact Support</a>
          </div>
          <p className="text-slate-400 dark:text-slate-600 text-xs">© 2024 uniscout.ai. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
